import { Link } from "react-router-dom";
import AppShell from "../shell/AppShell.jsx";
import "./states.css";

/**
 * P082/P083 built real screens under /backoffice/worker-intake and
 * /backoffice/job-supply, but Codex/owner rejected that entire post-login
 * design as confusing IA. Those old page components still exist on disk
 * (kept for recoverability), but App.jsx no longer imports or routes to
 * them - this catch-all replaces them for any old deep link so a visitor
 * sees a calm, honest "this was reset" message instead of the rejected UI
 * or a bare 404.
 */
export default function PostLoginResetNotice() {
  return (
    <AppShell crumbs={["Backoffice"]}>
      <div className="wx-state-card">
        <h1 className="wx-state-title">ส่วนนี้กำลังถูกออกแบบใหม่</h1>
        <p className="wx-state-body">
          หน้าที่คุณเปิดเป็นเวอร์ชันเก่าที่ถูกพักการใช้งานชั่วคราวระหว่างออกแบบใหม่ ระบบจะเปิดให้ใช้งานอีกครั้งเมื่อพร้อม
          กลับไปที่แดชบอร์ดเพื่อดูภาพรวมล่าสุดของแพลตฟอร์ม
        </p>
        <p className="wx-state-contact">
          <Link to="/backoffice">กลับไปแดชบอร์ด</Link>
        </p>
      </div>
    </AppShell>
  );
}
